






















import { Component, Prop, Vue } from 'vue-property-decorator'
import { PropType } from 'vue'
import _ from 'lodash'
import { TrelloLabel, TrelloCard } from '@/TrelloClient'
import { TrelloConfig, uiConfig } from '@/config'

@Component
export default class extends Vue {

    selectedLabel = 'all-labels'

    fetching = true

    labels: TrelloLabel[] = [] // etichette della board

    get options(): object[] {
        if (uiConfig.showLabelNamesInFilter) {
            return this.labels.map(this.trelloLabeToRadioOption)
        }
        return []
    }

    trelloLabeToRadioOption(label: TrelloLabel): object {
        return {
            value: label,
            text: _.startCase(_.toLower(label.name)),
        }
    }

    populateLabels() {
        this.fetching = true
        this.$store.state.trello.fetchBoardLabels(TrelloConfig.mainBoardId).then((labels: TrelloLabel[]) => {
            this.labels = labels
            this.fetching = false
        })
    }

    onLabelSelected(label: TrelloLabel) {
        console.log('Scelto una label da filtrare')
        this.$emit('labelSelected', label)
        this.$store.commit('updateActiveLabel', label)
        this.filterControl(label)
    }

    filterControl(label: TrelloLabel | 'all-labels' | 'with-labels' | 'without-labels') {
        if (label === 'all-labels') {
            this.$store.commit('removeCardFilter', { type: 'LABEL_FILTER' })
        } else if (label === 'with-labels') {
            this.$store.commit('updateCardFilter', {
                type: 'LABEL_FILTER',
                filter: (card: TrelloCard) => card.labels.length > 0,
            })
        } else if (label === 'without-labels') {
            this.$store.commit('updateCardFilter', {
                type: 'LABEL_FILTER',
                filter: (card: TrelloCard) => card.labels.length === 0,
            })
        } else {
            this.$store.commit('updateCardFilter', {
                type: 'LABEL_FILTER',
                filter: (card: TrelloCard) => card.labels.map(l => l.id).indexOf(label.id) !== -1,
            })
        }
    }

    mounted() {
        this.populateLabels()
    }
}
